import React from "react";
import { makeStyles } from "tss-react/mui";
import { Link } from "@mui/material";
import { alpha } from "@mui/material/styles";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";

import { i18n } from "../../translate/i18n";

const PRIVATE_REPLY_WINDOW_MS = 7 * 24 * 60 * 60 * 1000;

const useStyles = makeStyles()((theme) => ({
  banner: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.25),
    padding: theme.spacing(0.75, 1.5),
    borderTop: `1px solid ${theme.palette.divider}`,
    borderLeft: `3px solid ${theme.palette.info.main}`,
    background: alpha(theme.palette.info.main, 0.06),
    flexShrink: 0,
  },
  blocked: {
    borderLeftColor: theme.palette.warning.main,
    background: alpha(theme.palette.warning.main, 0.08),
  },
  icon: {
    fontSize: 20,
    color: theme.palette.info.main,
  },
  iconBlocked: {
    color: theme.palette.warning.main,
  },
  text: {
    flex: 1,
    fontSize: 13,
    lineHeight: 1.45,
  },
  link: {
    fontSize: 13,
    fontWeight: 600,
    whiteSpace: "nowrap",
  },
}));

const formatDeadline = (date) =>
  date.toLocaleString(i18n.language?.startsWith("en") ? "en-US" : "es-EC", {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });

const FacebookCommentBanner = ({ ticket }) => {
  const { classes, cx } = useStyles();
  const comment = ticket?.facebookComment;

  if (ticket?.channel !== "facebook" || !comment?.commentId || comment.customerRepliedAt) return null;

  const deadline = new Date(new Date(comment.commentedAt).getTime() + PRIVATE_REPLY_WINDOW_MS);
  const expired = !comment.repliedAt && Date.now() > deadline.getTime();
  const blocked = Boolean(comment.repliedAt) || expired;

  const message = comment.repliedAt
    ? i18n.t("facebookComment.waiting")
    : expired
      ? i18n.t("facebookComment.expired")
      : i18n.t("facebookComment.pending", { deadline: formatDeadline(deadline) });

  return (
    <div className={cx(classes.banner, { [classes.blocked]: blocked })}>
      <ChatBubbleOutlineOutlinedIcon className={cx(classes.icon, { [classes.iconBlocked]: blocked })} />
      <div className={classes.text}>{message}</div>
      {comment.permalink && (
        <Link href={comment.permalink} target="_blank" rel="noopener noreferrer" className={classes.link}>
          {i18n.t("facebookComment.viewPost")}
        </Link>
      )}
    </div>
  );
};

export default FacebookCommentBanner;
